<template>
  <v-form  ref="form" v-model="valid" lazy-validation>
    <v-overlay :value="overlay">
      <v-progress-circular
          indeterminate
          size="64"
      ></v-progress-circular>
    </v-overlay>
    <v-card>
      <v-card-text>
        <v-container fluid>
          <v-row>
            <v-col cols="12">
              <v-card>
                <v-card-text>
                  <v-container fluid>
                    <v-row>
                      <v-col cols="12" lg="6" md="6" sm="12">
                        <v-autocomplete
                            v-model="wybrany_klient"
                            :loading="isLoadingClients"
                            :items="clientsList"
                            :search-input.sync="clientKeyword"
                            cache-items
                            flat
                            no-data-text="Nieznaleziono"
                            hide-details
                            return-object
                            item-text="full_text"
                            item-value="id"
                            label="Wyszukaj pacjenta Imię/Nazwisko/PESEL"
                        >
                          <template slot="append-outer">
                            <v-btn fab small color="primary">
                              <v-icon  title="Szybkie dodanie pacjenta" @click="quickAddClient"
                                       v-if="$can('do','POKO_Klienci_Edycja')">fa-plus</v-icon>
                            </v-btn>
                          </template>
                          <template v-slot:selection="data">
                            <v-container fluid>
                              <v-row no-gutters>
                                <v-col>
                                  {{data.item.name + ' '+data.item.surname}}
                                </v-col>
                                <v-col>
                                  {{ data.item.description != null ? data.item.description.substr(0,19) : ''}}
                                </v-col>
                                <v-col>
                                  {{data.item.pesel}}
                                </v-col>
                                <v-col class="text-right">
                                  <v-icon class="mr-2">fa-phone</v-icon>{{data.item.phone}}
                                </v-col>
                              </v-row>
                            </v-container>
                          </template>
                          <template v-slot:item="data">
                            <v-container fluid>
                              <v-row no-gutters>
                                <v-col>
                                  {{data.item.name + ' '+data.item.surname}}
                                </v-col>
                                <v-col>
                                  {{ data.item.description != null ? data.item.description.substr(0,19) : ''}}
                                </v-col>
                                <v-col>
                                  {{data.item.pesel}}
                                </v-col>
                                <v-col class="text-right">
                                  <v-icon class="mr-2">fa-phone</v-icon>{{data.item.phone}}
                                </v-col>
                              </v-row>
                            </v-container>
                          </template>
                        </v-autocomplete>
                      </v-col>
                      <v-col cols="12" lg="6" md="6" sm="12">
                        <v-autocomplete
                            v-model="wybrany_terapeuta"
                            name="therapistId" :loading="isLoadingTherapists"
                            :items="therapists"
                            flat
                            return-object
                            hide-details
                            prepend-icon="fa-search"
                            label="Wyszukaj terapeute Imię/Nazwisko"
                        >
                        </v-autocomplete>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" lg="6" md="6" sm="12" v-if="filteredtypywizyt && filteredtypywizyt.length > 0">
                        <v-select :items="filteredtypywizyt" item-text="nazwa"
                                  label="Typ wizyty terapeuty" placeholder="Wybierz typ wizyty_terapeuty..."
                                  v-model="wybrany_typ_wizyty"
                                  return-object
                                  clearable
                        ></v-select>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" lg="6" md="6" sm="12">
                        <v-select v-model="priority" :items="priorities" label="Priorytet"></v-select>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" lg="6" md="6" sm="12">
                        <v-textarea v-model="notes" label="Uwagi"></v-textarea>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <v-dialog v-model="addQuickClientDialog" max-width="500px" v-if="$can('do','POKO_Klienci_Edycja')">
                          <v-card>
                            <v-toolbar dark class="primary">
                              <v-btn icon @click.native="addQuickClientDialog = false" dark>
                                <v-icon>fa-times</v-icon>
                              </v-btn>
                              <v-toolbar-title>Szybkie dodanie pacjenta</v-toolbar-title>
                            </v-toolbar>
                            <v-progress-linear :indeterminate="true" v-if="quickClientSaving"></v-progress-linear>
                            <v-card-text v-show="!quickClientSaving">
                              <v-form data-vv-scope="quickAddForm" @submit.prevent="saveQuickClient">
                                <v-container fluid>
                                  <v-row>
                                    <v-col cols="12">
                                      <v-text-field label="Imię*" v-validate="'required'" name="qaddname" id="qaddname"
                                                    data-vv-as="Imię"
                                                    :error-messages="errors.collect('quickAddForm.qaddname')"
                                                    v-model="quickAddPatientData.name"></v-text-field>
                                    </v-col>
                                  </v-row>
                                  <v-row>
                                    <v-col cols="12">
                                      <v-text-field label="Nazwisko*" v-validate="'required'" name="qaddsurname"
                                                    id="qaddsurname"
                                                    :error-messages="errors.collect('quickAddForm.qaddsurname')"
                                                    data-vv-as="Nazwisko"
                                                    v-model="quickAddPatientData.surname"></v-text-field>
                                    </v-col>
                                  </v-row>
                                  <v-row>
                                    <v-col cols="12">
                                      <v-text-field label="Krótki opis" v-model="quickAddPatientData.description"></v-text-field>
                                    </v-col>
                                  </v-row>
                                  <v-row>
                                    <v-col cols="12">
                                      <v-text-field label="Telefon" v-validate="{regex:/^[0-9\+]{8,13}$/}" name="qaddphone"
                                                    id="qaddphone"
                                                    :error-messages="errors.collect('quickAddForm.qaddphone')"
                                                    data-vv-as="Telefon" v-model="quickAddPatientData.phone"></v-text-field>
                                    </v-col>
                                  </v-row>
                                  <v-row>
                                    <v-col cols="12">
                                      <v-checkbox label="Zgoda na sms" v-model="quickAddPatientData.zgoda_na_sms"></v-checkbox>
                                    </v-col>
                                  </v-row>
                                </v-container>
                              </v-form>
                            </v-card-text>
                            <v-card-actions v-show="!quickClientSaving">
                              <v-btn color="success" @click="saveQuickClient">Zapisz</v-btn>
                              <v-btn color="error" @click="addQuickClientDialog=false">Anuluj</v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-card>
                <v-card-text>
                  <v-container fluid>
                    <v-row>
                      <v-col cols="12">
                        <ReserveSchedules :schedules.sync="reserveSchedules"></ReserveSchedules>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="success" @click="save">Zapisz</v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import {clientService, reserveService, therapistsService} from "@/services";

import swal from "sweetalert";
import ReserveSchedules from "@/components/reserves/ReserveSchedules";

export default {
  name: "AddReserve",
  components: {ReserveSchedules},
  data() {
    return {
      valid: true,
      isLoadingClients: false,
      clientKeyword: null,
      overlay: false,
      wybrany_klient: null,
      wybrany_terapeuta: null,
      isLoadingTherapists: false,
      therapists: [],
      clientTimerId: 0,
      notes: null,
      clientsList: [],
      wybrany_typ_wizyty: null,
      reserveSchedules: [],
      typywizyt:[],
      addQuickClientDialog: false,
      quickAddPatientData: {
        name: null,
        surname: null,
        phone: null,
        zgoda_na_sms: false,
        description: null
      },
      quickClientSaving: false,
      priority: 0,
      priorities: [
        {
          text: 'Normalny',
          value: 0
        },
        {
          text: 'Terapeuta',
          value: 1
        },
        {
          text: 'VIP',
          value: 2
        }
      ]
    }
  },
  watch: {
    clientKeyword(val) {
      if (val) {
        this.fetchClientDebaunce();
      }
    },
    wybrany_klient() {
      this.checkExistance()
    },
    wybrany_terapeuta() {
      this.checkExistance()
    }
  },
  computed: {
    filteredtypywizyt: function() {
      if(this.wybrany_terapeuta != null)
      {
        let lst = []
        lst = this.typywizyt.map(obj=> ({...obj, disabled: !obj.aktywna}))
        return lst.filter(x=>x.terapeuta_id == this.wybrany_terapeuta.id)
      }
      return []
    },
  },
  mounted() {
    this.loadTherapists()
    this.getAllTypyWizyt()
  },
  methods: {
    checkExistance()
    {

      if(this.wybrany_klient && this.wybrany_terapeuta)
      {
        this.overlay = true
        reserveService.checkReserve({
          clientid: this.wybrany_klient.id,
          therapistid: this.wybrany_terapeuta.id
        }).then((result)=> {
          this.overlay = false
          if(result.data.result > 0)
          {
            this.showError('Wybrany klient ma już wizyte rezerwową dla tego terapeuty')
            this.wybrany_klient = null
            this.wybrany_terapeuta = null
            return
          }
        }).catch(() => {
          this.overlay = false
          this.showError('Błąd sprawdzania rezerw.')
        })
      }
    },
    save()
    {
      if(this.wybrany_klient == null)
      {
        this.showError('Nie wybrano klienta')
        return
      }
      if(this.wybrany_terapeuta == null)
      {
        this.showError('Nie wybrano terapeuty')
        return
      }
      this.overlay = true
      reserveService.create({
        clientId: this.wybrany_klient.id,
        therapistId: this.wybrany_terapeuta.id,
        typWizytyTerapeutyId: this.wybrany_typ_wizyty != null ?  this.wybrany_typ_wizyty.id : 0,
        priority: this.priority,
        notes: this.notes,
        reserveSchedules: this.reserveSchedules
      }).then(result => {
        this.$emit('OnAddedReserve',result.data.result)
        this.overlay = false
      }).catch( resp=> {
        if (
            resp.response != null &&
            resp.response.data != null &&
            resp.response.data.error != null
        ) {
          this.showError( resp.response.data.error.message,false);
        } else {
          this.showError( "Błąd zapisu wizyty rezerwowej", false);
        }

      })
    },
    getAllTypyWizyt() {
      therapistsService.GetWszystkieTypyWizyt().then(result => {
        this.typywizyt = result.data.result
      }).catch(() => {
        this.error("Nie można pobrać typów wizyt terapeutów.");
      })
    },
    loadTherapists() {
      this.isLoadingTherapists = true;
      therapistsService
          .getAll({query: '', page: 1, limit: 1000, })
          .then(response => {
            if (
                response.data != null &&
                response.data.result != null &&
                response.data.result.items != null
            ) {

              response.data.result.items.forEach((r, index) => {
                if (!this.therapists.find(x => x.id === r.id))
                  if(r.isActive) {
                    this.therapists.push({
                      id: r.id,
                      text: r.name + " " + r.surname,
                      pay: r.rate,
                      disabled: false
                    });
                  }
              });
              this.isLoadingTherapists = false;
            } else {
              throw "error pobierania terapeutów";
            }
          })
          .catch(e => {
            this.isLoadingTherapists = false;
            this.showError( "Nie można pobrać listy terapeutów.");
          });
    },
    quickAddClient() {
      this.quickAddPatientData.name = null;
      this.quickAddPatientData.surname = null;
      this.quickAddPatientData.phone = null;
      this.quickAddPatientData.zgoda_na_sms = false;
      this.quickAddPatientData.description = null;
      this.addQuickClientDialog = true;
    },
    fetchClientDebaunce() {
      // cancel pending call
      clearTimeout(this.clientTimerId)
      // delay new call 500ms
      this.clientTimerId = setTimeout(() => {
        this.getClientValues()
      }, 500)
    },
    showError( text) {
      swal({
        title: "Błąd",
        text: text,
        icon: "warning",
        button: "OK"
      }).then(() => {
        this.loading = false;
        this.isLoadingTherapists = false;
      });
    },
    saveQuickClient() {
      this.$validator.validateAll("quickAddForm").then(valid => {
        if (valid) {
          this.quickClientSaving = true;
          clientService
              .create({
                name: this.quickAddPatientData.name,
                surname: this.quickAddPatientData.surname,
                phone: this.quickAddPatientData.phone,
                agreeForHealthServices: true,
                usePhoneForSMS: this.quickAddPatientData.zgoda_na_sms && this.quickAddPatientData.phone && this.quickAddPatientData.phone.length > 0,
                patientConfirmVisitsBySMS: this.quickAddPatientData.zgoda_na_sms && this.quickAddPatientData.phone && this.quickAddPatientData.phone.length > 0,
                patientAgreeToReceiveSMS: this.quickAddPatientData.zgoda_na_sms && this.quickAddPatientData.phone && this.quickAddPatientData.phone.length > 0,
                description: this.quickAddPatientData.description
              })
              .then(resp => {
                this.quickClientSaving = false;
                this.quickAddPatientData.name = null;
                this.quickAddPatientData.surname = null;
                this.quickAddPatientData.phone = null;
                this.quickAddPatientData.zgoda_na_sms = false
                this.quickAddPatientData.description = null
                this.addQuickClientDialog = false;
                if (resp.data != null && resp.data.result != null) {
                  var quickClient = resp.data.result;
                  let newClient = {
                    id: quickClient.id,
                    name: quickClient.name,
                    surname: quickClient.surname,
                    pesel: quickClient.pesel,
                    therapist: quickClient.therapistID,
                    full_text: quickClient.name + ' '+quickClient.surname + (quickClient.pesel != null && quickClient.pesel != '' ? ' '+quickClient.pesel : '') + (quickClient.phone != null && quickClient.phone != '' ? ' '+quickClient.phone : ''),
                    disabled:false,
                    description: quickClient.description,
                    phone: quickClient.phone
                  };
                  this.clientsList.push(newClient);
                  this.wybrany_klient = newClient
                } else {
                  this.showError( "Błąd zapisu pacjenta");
                }
              })
              .catch(resp => {
                this.quickClientSaving = false;
                if (
                    resp.response != null &&
                    resp.response.data != null &&
                    resp.response.data.error != null
                ) {
                  this.showError( resp.response.data.error.message);
                } else {
                  this.showError( "Błąd zapisu pacjenta");
                }
              });
        }
      });
    },
    getClientValues() {
      this.isLoadingClients = true;
      clientService
          .getAll({query: this.clientKeyword, page: 1, limit: 20, sorting: "surname"})
          .then(data => {
            data.data.result.items.forEach(item => {
              if (!this.clientsList.find(x => x.id === item.id)) {
                let name = item.name + " " + item.surname;
                if (item.pesel != null && item.pesel != "")
                  name = name + "/" + item.pesel;
                if(item.phone != null && item.phone != "")
                  name = name + " tel: "+item.phone;
                this.clientsList.push({
                  id: item.id,
                  name: item.name,
                  surname: item.surname,
                  pesel: item.pesel,
                  therapist: item.therapistID,
                  full_text: item.name + ' '+item.surname + (item.pesel != null && item.pesel != '' ? ' '+item.pesel : '') + (item.phone != null && item.phone != '' ? ' '+item.phone : ''),
                  disabled:false,
                  description: item.description,
                  phone: item.phone
                });
              }
            });
            this.isLoadingClients = false;
          })
          .catch(() => {
            this.isLoadingClients = false;
            this.showError( "Nie można pobrać listy klientów.");
          });
    },
  }
}
</script>

<style scoped>

</style>